/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Check_ConnectionInputs */

const vi_grower_area_camera_check_connection = /** @type {(inputs: Grower_Area_Camera_Check_ConnectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra kết nối`)
};

/**

* @param {Grower_Area_Camera_Check_ConnectionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_check_connection = /** @type {((inputs?: Grower_Area_Camera_Check_ConnectionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Check_ConnectionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_check_connection(inputs)
});